import { IdFuncs } from '../../../common/core/id/id.funcs';
import { EffectTypeWire } from './effect-type.wire';
import { EffectWire } from './effect.wire';

function init<T = any>(effect: Partial<EffectWire<T>>): EffectWire<T> {
  effect.id = effect.id ?? IdFuncs.generate();
  return effect as EffectWire<T>;
}

function updateEffect({ effects, effect }: { effects: EffectWire<any>[]; effect: EffectWire<any> }) {
  const index = effects.findIndex((e) => e.id === effect.id);
  if (index !== -1) {
    effects[index] = effect;
  }
}

function addEffect({ effects, effect }: { effects: EffectWire<any>[]; effect: EffectWire<any> }) {
  effects.push(effect);
}

function removeEffect({ effects, effect }: { effects: EffectWire<any>[]; effect: EffectWire<any> }) {
  const index = effects.findIndex((e) => e.id === effect.id);
  if (index !== -1) {
    effects.splice(index, 1);
  }
}

function hasEffect({ effects, type }: { effects: EffectWire<any>[]; type: EffectTypeWire }) {
  return effects.some((e) => e.type === type);
}

function findEffect<T = any>({ effects, type }: { effects: EffectWire<T>[]; type: EffectTypeWire }): EffectWire<T> | undefined {
  return effects.find((e) => e.type === type);
}

export const EffectWireFuncs = {
  init,
  updateEffect,
  addEffect,
  removeEffect,
  hasEffect,
  findEffect,
};
